module.exports = __webpack_public_path__ + "img/焦槟榔.03625594.jpg";